module.exports = __webpack_public_path__ + "img/dairy-products.d453ac5d.png";